import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private _currentUser: any = null;
  private _currentCharity: any = null;
  private currentCharityID: any = null;
  private _currentAccontingPeriod: any = null;
  private readonly currentUserKey: string = 'currentUser'
  private readonly currentCharityKey: string = 'currentCharity'
  private readonly currentAccontingPeriodKey: string = 'currentAccontingPeriod'
  private _centralUserID: any = null;
  private readonly centralUserIDKey: string = 'centralUserID'
  private _userID: any = null;
  private readonly userIDKey: string = 'userID'
  CompaniesCreated: number = 0
  CharitiesCreated: number = 0

  constructor() {

   //// const currentUser: string = localStorage.getItem(this.currentUserKey);
   // if (currentUser !== null && currentUser !== undefined && currentUser !== "") {
   //   this._currentUser = JSON.parse(currentUser);
   // } else {
   //   this._currentUser = null;
   // }

}



  public setCurrentUser(currentUser: any) {
    localStorage.setItem(this.currentUserKey, JSON.stringify(currentUser));
    this._currentUser = currentUser;
  }
  public setCurrentCharity(currentCharity: any) {
    localStorage.setItem(this.currentCharityKey, JSON.stringify(currentCharity));
    this._currentCharity = currentCharity;
  }
  public setcurrentCharityID(currentCharityID: any) {
    localStorage.setItem('currentCharityID', currentCharityID);
    this.currentCharityID = currentCharityID;
  }
 

  public setCurrentAccountingPeriod(currentAccontingPeriod: any) {
   // localStorage.setItem(this.currentAccontingPeriodKey, JSON.stringify(currentAccontingPeriod));
    this._currentAccontingPeriod = currentAccontingPeriod;
  }

  //Get current user
  public get getcurrentCharityID(): any {
    return this.currentCharityID;
  }
  //Get current user
  public get getCurrentCharity(): any {
    return this._currentCharity;
  }
  //Get current user
  public get getCurrentUser(): any {
  return this._currentUser;
  }

  public get getCurrentAccountingPeriod(): any {
    return this._currentAccontingPeriod;
  }


  public setCentralUserID(centralUserID: any) {
    localStorage.setItem(this.centralUserIDKey, JSON.stringify(centralUserID));
    this._centralUserID = centralUserID;
  }

  //Get current user
  public get getCentralUserID(): any {
    return this._centralUserID;
  }

  public setUserID(userID: any) {
    localStorage.setItem(this.userIDKey, JSON.stringify(userID));
    this._userID = userID;
  }

  //Get current user
  public get getUserID(): any {
    return this._userID;
  }


}
